import { createMuiTheme } from '@material-ui/core';

const toaTheme = createMuiTheme({
	palette: {
		primary: {
			main: '#8524AA', // Primary purple
		},
		secondary: {
			main: '#CC4E00',
		},
		error: {
			main: '#B00020',
		},
	},
	zIndex: {
		appBar: 1500,
	},
});

export { toaTheme };
